import React, { useState } from "react";

export default function TagInput({ value = [], onChange, placeholder = "Add tag…" }) {
  const [draft, setDraft] = useState("");

  const add = (raw) => {
    const v = String(raw || "").trim().replace(/^#/, "");
    if (!v) return;
    if (value.includes(v)) { setDraft(""); return; }
    onChange([...value, v]);
    setDraft("");
  };

  const remove = (i) => onChange(value.filter((_, j) => j !== i));

  const onKey = (e) => {
    if (e.key === "Enter" || e.key === "," || e.key === "Tab") {
      if (draft.trim()) {
        e.preventDefault();
        add(draft);
      }
    } else if (e.key === "Backspace" && !draft && value.length) {
      onChange(value.slice(0, -1));
    }
  };

  return (
    <div className="tag-input">
      {value.map((t, i) => (
        <span key={i}>
          #{t}
          <button type="button" aria-label={`Remove ${t}`} onClick={() => remove(i)}>×</button>
        </span>
      ))}
      <input
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
        onKeyDown={onKey}
        onBlur={() => draft.trim() && add(draft)}
        placeholder={placeholder}
      />
    </div>
  );
}
